import styled from '@emotion/styled';

import { Modal, ModalFooterStyles } from '../Modal';

const ConfirmationModal = styled(Modal)(({ theme }) => ({
  [`${ModalFooterStyles.sel.Footer}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.eclipseTier1.spacing['16px'],
    gap: theme.eclipseTier1.spacing['8px'],
  },
}));

export const S = {
  ConfirmationModal,
} as const;
